/*
 * auth (utils)
 */
import type { AuthUser, UserRole } from "@emr/types"
import { AppPlatform } from "./environment.utils"

export function getWaitlistMetadata(user?: AuthUser | null) {
	return user?.app_metadata?.waitlist || []
}

export function isOnWaitlist(user?: AuthUser | null): boolean {
	return getWaitlistMetadata(user).includes(AppPlatform)
}

export function getAppMetadata(user?: AuthUser | null) {
	return user?.app_metadata || null
}

export function getPlatformMetadata(user?: AuthUser | null) {
	return user?.app_metadata?.[AppPlatform] || null
}

export function getUserRole(user?: AuthUser | null): UserRole {
	return getPlatformMetadata(user)?.role || "guest"
}

export function isAdmin(user?: AuthUser | null): boolean {
	return getPlatformMetadata(user)?.role === "admin" || false
}
